import React from 'react';
import { Zap, MapPin, Star, ShieldCheck } from 'lucide-react';

/**
 * DriverPreferenceSelector — segmented 4-way toggle the customer taps at
 * checkout to influence who gets the order. Value maps 1:1 to the backend
 * `driver_preference` order field.
 */
const OPTIONS = [
  { key: 'auto',    icon: Zap,         title: 'Auto',        subtitle: 'System picks best match' },
  { key: 'nearest', icon: MapPin,      title: 'Nearest',     subtitle: 'Closest online driver' },
  { key: 'best',    icon: Star,        title: 'Best rated',  subtitle: 'Highest star average' },
  { key: 'super',   icon: ShieldCheck, title: 'Super Driver', subtitle: 'Priority handling' },
];

const DriverPreferenceSelector = ({ value = 'auto', onChange, disabled }) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h3 className="font-semibold text-slate-900">Who should deliver this?</h3>
          <p className="text-xs text-slate-500 mt-0.5">
            Auto matches like normal. Nearest / Best give one driver a 60-second head-start before the order opens to the whole zone.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" role="radiogroup" aria-label="Driver preference">
        {OPTIONS.map(({ key, icon: Icon, title, subtitle }) => {
          const active = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange?.(key)}
              disabled={disabled}
              data-testid={`driver-pref-${key}`}
              aria-pressed={active}
              className={`text-left rounded-xl border p-3 transition-all ${
                active
                  ? 'border-emerald-500 bg-emerald-50 ring-2 ring-emerald-200'
                  : 'border-slate-200 bg-white hover:border-slate-300'
              }`}
            >
              <div className={`h-8 w-8 rounded-lg flex items-center justify-center mb-1.5 ${active ? 'bg-emerald-600 text-white' : 'bg-slate-100 text-slate-600'}`}>
                <Icon className="h-4 w-4" />
              </div>
              <div className={`text-sm font-semibold ${active ? 'text-emerald-800' : 'text-slate-900'}`}>{title}</div>
              <div className="text-[11px] text-slate-500 mt-0.5 leading-snug">{subtitle}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DriverPreferenceSelector;
